import { Injectable } from '@angular/core';
import { Policies } from '@app/auth/auth-policies';
import { AuthService } from '@app/auth/auth.service';
import { Subject } from 'rxjs';
import { PhotoMetaData } from './../models/photo/photo-meta-data';
import { SignalrBase } from './signalr-base';
import { SignalrHttpClientService } from './signalr-http-client.service';
import { DeviceEvent } from '@models/photo/device-event';

@Injectable({
  providedIn: 'root',
})
export class PhotoSignalrService extends SignalrBase<any> {
  private photosChanged = new Subject<PhotoMetaData>();
  photosChanged$ = this.photosChanged.asObservable();

  private cameraNotFound = new Subject<DeviceEvent>();
  public cameraNotFound$ = this.cameraNotFound.asObservable();

  private cameraError = new Subject<DeviceEvent>();
  public cameraError$ = this.cameraError.asObservable();

  private cameraConnected = new Subject<DeviceEvent>();
  public cameraConnected$ = this.cameraConnected.asObservable();

  private cameraDisconnected = new Subject<DeviceEvent>();
  public cameraDisconnected$ = this.cameraDisconnected.asObservable();

  private cameraShutDown = new Subject<DeviceEvent>();
  public cameraShutDown$ = this.cameraShutDown.asObservable();

  constructor(authService: AuthService, private signalrHttpClientService: SignalrHttpClientService) {
    // Permissions to have this connect
    super('Photos', Policies.patientPhotos, authService, signalrHttpClientService);
    this.registerServerEvents();
  }

  private registerServerEvents(): void {
    super.registerServerEvent('AddPhoto', (photo: PhotoMetaData) => {
      this.photosChanged.next(photo);
    });

    super.registerServerEvent('UpdatePhoto', (photo: PhotoMetaData) => {
      this.photosChanged.next(photo);
    });

    super.registerServerEvent('DeletePhoto', (photo: PhotoMetaData) => {
      this.photosChanged.next(photo);
    });

    super.registerServerEvent('CameraNotFound', (deviceEvent: DeviceEvent) => {
      this.cameraNotFound.next(deviceEvent);
    });

    super.registerServerEvent('CameraError', (deviceEvent: DeviceEvent) => {
      this.cameraError.next(deviceEvent);
    });

    super.registerServerEvent('CameraConnected', (deviceEvent: DeviceEvent) => {
      this.cameraConnected.next(deviceEvent);
    });

    super.registerServerEvent('CameraDisconnected', (deviceEvent: DeviceEvent) => {
      this.cameraDisconnected.next(deviceEvent);
    });

    super.registerServerEvent('CameraShutDown', (deviceEvent: DeviceEvent) => {
      this.cameraShutDown.next(deviceEvent);
    });
  }

  // updatePhoto(photo: PhotoMetaData){
  //   this._hubConnection.invoke('UpdatePhotoFromClient', photo);
  // }

  // addPhoto(photo: PhotoMetaData){
  //   this._hubConnection.invoke('AddPhotoFromClient', photo);
  // }

  // deletePhoto(photo: PhotoMetaData){
  //   this._hubConnection.invoke('DeletePhotoFromClient', photo);
  // }
}
